import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const fallbackLng = ['en']

i18n
   .use(HttpApi)
   .use(initReactI18next)
   .init({
      fallbackLng,
      backend: {
         loadPath: './assets/i18n/translations/{{lng}}/{{ns}}.json'
      },
      ns: ['common'],
      defaultNS: 'common'
   })

i18n.loadNamespaces([
   'assignFriend',
   'calls',
   'common',
   'pipelineItemScheduling',
   'selfServeLeadTemplate',
   'selfServeTemplates',
   'globalSearch',
   'sidepane',
   'boards',
   'views',
   'sidebar',
   'tableView',
   'auth',
   'automationWorkFlows',
   'leadDetails',
   'analytics',
   'parameterStore',
   'advancedFilters',
   'reminders',
   'crmItemDetailedView',
   'leadDistribution',
   'operationsHub',
   'simpleTable',
   'navbar',
   'crmItemCreation',
   'templatesCore',
   'customObject',
   'pipelineEvents',
   'cloudCalling',
   'pipelineActivities',
   'selfServeTaskTemplate',
   'scrutinyKey',
   'stages',
   'userTemplate',
   'whatsappIntegrations',
   'pipelineSettings',
   'sharableResources',
   'dealTemplate',
   'notifications',
   'applicationTemplate',
   'portals',
   'displayStages',
   'documentTemplates',
   'scoring',
   'plugins',
   'assigneeGroups',
   'selfServeCommon',
   'dataCoPilot',
   'aiChatSupport',
   'notes',
   'paymentRequests',
   'remarks',
   'feeEngine',
   'sharedWebCommon',
   'payments',
   'feeCalculator',
   'shortfalls',
   'fields',
   'client',
   'pmuPortal',
   'legacyApplication',
   'searchAndMonitoring',
   'permissions'
])

export default i18n
